<div>
    <span><b>{{data.title}}</b></span>
    <br>
    <span>{{data.message}}</span>
    <div class="dismiss">
      <button mat-icon-button (click)="sbRef.dismiss()">
          <mat-icon class="icon">close</mat-icon>
        </button>
    </div>
  </div> 